import { sum, trim, uniqBy } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import toEnglishNumber from '../../utils/toEnglishNumber';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  products: [],
  product: null,
  checkout: {
    activeStep: 0,
    cart: [],
    weight: 0,
    subtotal: 0,
    total: 0,
    discount: 0,
    shipping: 0,
    billing: null,
    totalItems: 0,
  },
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getProductsSuccess(state, action) {
      state.isLoading = false;
      state.products = action.payload;
    },

    // GET PRODUCT
    getProductSuccess(state, action) {
      state.isLoading = false;
      state.product = action.payload;
    },

    // CHECKOUT
    getCart(state, action) {
      // console.log('CHECKOUT!!!!');

      const cart = action.payload;

      const totalItems = sum(cart.map((product) => product.quantity));
      const subtotal = sum(cart.map((product) => product.Price * product.quantity));
      const weight = sum(cart.map((product) => product.PRDMWeight * product.quantity));
      state.checkout.cart = cart;
      state.checkout.weight = weight;
      state.checkout.discount = state.checkout.discount || 0;
      state.checkout.shipping = state.checkout.shipping || 0;
      state.checkout.billing = state.checkout.billing || null;
      state.checkout.subtotal = subtotal;
      state.checkout.total = subtotal - state.checkout.discount;
      state.checkout.totalItems = totalItems;
    },

    addToCart(state, action) {
      // console.log('addToCart!!!');
      // console.log(action.payload);

      const newProduct = action.payload;
      const isEmptyCart = !state.checkout.cart.length;
      if (isEmptyCart) {
        state.checkout.cart = [...state.checkout.cart, newProduct];
      } else {
        state.checkout.cart = state.checkout.cart.map((product) => {
          const isExisted = product.Id === newProduct.Id;

          if (isExisted) {
            return {
              ...product,
              quantity: product.quantity + 1,
              rowWeight: product.PRDMWeight,
            };
          }

          return product;
        });
      }
      state.checkout.cart = uniqBy([...state.checkout.cart, newProduct], 'Id');
      state.checkout.totalItems = sum(state.checkout.cart.map((product) => product.quantity));
    },

    deleteCart(state, action) {
      const updateCart = state.checkout.cart.filter((product) => product.Id !== action.payload);

      state.checkout.cart = updateCart;
    },

    resetCart(state) {
      state.checkout.cart = [];
      state.checkout.billing = null;
      state.checkout.activeStep = 1;
      state.checkout.weight = 0;
      state.checkout.total = 0;
      state.checkout.subtotal = 0;
      state.checkout.discount = 0;
      state.checkout.shipping = 0;
      state.checkout.totalItems = 0;
      state.checkout.paidType = 0;
    },

    backStep(state) {
      state.checkout.activeStep -= 1;
    },

    nextStep(state) {
      state.checkout.activeStep += 1;
    },

    gotoStep(state, action) {
      const step = action.payload;
      state.checkout.activeStep = step;
    },

    changeQuantity(state, action) {
      const { event, productId } = action.payload;
      const updateCart = state.checkout.cart.map((product) => {
        if (product.Id === productId) {
          let qty = 1;
          if (trim(event) !== '') {
            qty = toEnglishNumber(event);
          }

          return {
            ...product,
            quantity:
              Number(qty) <= Number(product.WeightQTY) ? Number(qty) : Number(product.WeightQTY),
            rowWeight:
              Number(qty) <= Number(product.WeightQTY)
                ? product.PRDMWeight * Number(qty)
                : product.PRDMWeight * Number(product.WeightQTY),
          };
        }

        return product;
      });
      state.checkout.cart = updateCart;
    },

    increaseQuantity(state, action) {
      const productId = action.payload;

      const updateCart = state.checkout.cart.map((product) => {
        if (product.Id === productId) {
          return {
            ...product,
            quantity: product.quantity + 1,
            rowWeight: product.rowWeight + Number(product.PRDMWeight),
          };
        }
        return product;
      });

      state.checkout.cart = updateCart;
    },

    decreaseQuantity(state, action) {
      const productId = action.payload;

      const updateCart = state.checkout.cart.map((product) => {
        if (product.Id === productId) {
          return {
            ...product,
            quantity: product.quantity - 1,
            rowWeight: product.rowWeight - Number(product.PRDMWeight),
          };
        }
        return product;
      });

      state.checkout.cart = updateCart;
    },

    createBilling(state, action) {
      state.checkout.billing = action.payload;
      // console.log('OK!!!');
      // console.log('state.checkout.billing : ', state.checkout.billing);
    },

    applyDiscount(state, action) {
      const discount = action.payload;
      state.checkout.discount = discount;
      state.checkout.total = state.checkout.subtotal - discount;
    },

    applyShipping(state, action) {
      const shipping = action.payload;
      state.checkout.shipping = shipping;
      state.checkout.total = state.checkout.subtotal - state.checkout.discount + shipping;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  changeQuantity,
  increaseQuantity,
  decreaseQuantity,
  getProductsSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

// export function getProducts() {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.get('/API/Services/GetSupplyBoard');
//       // console.log(response.data);
//       dispatch(slice.actions.getProductsSuccess(response.data));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }

export function getProducts(g3id, g2id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const obj = {
        G2Id: g2id,
        G3Id: g3id,
      };
      const response = await axios.post('/API/Services/GetSupplyBoardByBrand', obj);
      // console.log(response.data);
      dispatch(slice.actions.getProductsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getProduct(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/API/Services/GetPRDM', {
        params: { id },
      });
      dispatch(slice.actions.getProductSuccess(response.data.product));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
